import styled from 'styled-components';
import { rem } from 'polished';

const ColorEntryItem = styled.div`
    padding: ${rem(8)} 0;
`;

export default ColorEntryItem;
